import PublicIcon from "@mui/icons-material/Public";
import { Avatar, Box } from "@mui/material";
import { getTagAvatarUrl, tagUsesPublicIcon } from "../utils/tagAvatarUtils";

/** Chip avatar: image or MUI Public for the "country" tag. */
export function TagChipAvatar({ tag, size }) {
    if (tagUsesPublicIcon(tag)) {
        const fontSize = Math.round(size * 0.78);
        return (
            <Avatar alt="" sx={{ width: size, height: size, bgcolor: "transparent", color: "text.secondary" }}>
                <PublicIcon sx={{ fontSize }} />
            </Avatar>
        );
    }
    return <Avatar src={getTagAvatarUrl(tag)} alt="" sx={{ width: size, height: size }} />;
}

/** Row header icon: circular img or Public in a circle (e.g. Netflix-style tag rows). */
export function TagRowLeadIcon({ tag, size }) {
    if (tagUsesPublicIcon(tag)) {
        const fontSize = Math.round(size * 0.78);
        return (
            <Box
                sx={{
                    width: size,
                    height: size,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "text.secondary",
                    bgcolor: (theme) => theme.palette.action.hover,
                }}
            >
                <PublicIcon sx={{ fontSize }} />
            </Box>
        );
    }
    return (
        <Box
            component="img"
            src={getTagAvatarUrl(tag)}
            alt=""
            sx={{ width: size, height: size, borderRadius: "50%", objectFit: "cover" }}
        />
    );
}
